import { useSelector } from 'react-redux';
import { AuthEntity } from '_entities';

const { getAgenciesList } = AuthEntity.selectors;

// P20M-1338: members of a BOH/Unf agency may access the Synar Inspection
// Report without the view_synar_inspection_report permission. Exact
// (case-insensitive) agency-name match, mirroring the backend
// MA_SYNAR_AGENCY_NAMES constant.
const SYNAR_AGENCY_NAMES = ['boh', 'unf'];

function IsSynarAgencyMember() {
  const agencies = useSelector(getAgenciesList);
  return (agencies || []).some((agency) => SYNAR_AGENCY_NAMES.includes(agency?.attributes?.name?.toLowerCase()));
}

export default IsSynarAgencyMember;
